import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

const SKIP_LOADING = { headers: new HttpHeaders({ 'X-Skip-Loading-Bar': 'true' }) };

export interface ChatMessage {
    id: number;
    role: 'user' | 'assistant';
    content: string;
    status: 'sent' | 'pending' | 'delivered' | 'error';
    created_at: string;
}

export interface SendResponse {
    session_id: string;
    message_id: string;
    question: string;
    answer: string;
    status: string;
}

export interface DynamoMessage {
    message_id: string;
    session_id: string;
    question: string;
    answer: string;
    status: string;
    asked_at: number;
    asked_at_iso: string;
}

export interface MessagesResponse {
    messages: DynamoMessage[];
}

@Injectable({ providedIn: 'root' })
export class ChatService {
    private http = inject(HttpClient);

    sendMessage(message: string, sessionId?: string): Observable<SendResponse> {
        return this.http.post<SendResponse>(`${environment.apiUrl}/api/v1/chat/send`, {
            message,
            session_id: sessionId,
        }, SKIP_LOADING);
    }

    getMessages(sessionId?: string): Observable<MessagesResponse> {
        const params: any = {};
        if (sessionId) params.session_id = sessionId;
        return this.http.get<MessagesResponse>(`${environment.apiUrl}/api/v1/chat/messages`, { params, ...SKIP_LOADING });
    }

    /** Hide what was said so far. The messages stay in the database. */
    clear(): Observable<{ cleared_at: number }> {
        return this.http.post<{ cleared_at: number }>(`${environment.apiUrl}/api/v1/chat/clear`, {}, SKIP_LOADING);
    }

    newSession(): Observable<{ session_id: string }> {
        return this.http.post<{ session_id: string }>(`${environment.apiUrl}/api/v1/chat/new-session`, {}, SKIP_LOADING);
    }
}
